import { Box } from '@mui/material';

interface SidebarCollapseHitAreaProps {
  isExpanded: boolean;
  onClick: () => void;
}

/**
 * Fills the gap between the last nav item and the pinned footer. Clicking
 * this region collapses or expands the sidebar.
 */
export function SidebarCollapseHitArea({
  isExpanded,
  onClick,
}: SidebarCollapseHitAreaProps) {
  return (
    <Box
      flex={1}
      width="100%"
      minHeight={0}
      onClick={onClick}
      data-testid="sidebar-collapse-hit-area"
      sx={{ cursor: isExpanded ? 'w-resize' : 'e-resize' }}
    />
  );
}
